export default class Circle {
  constructor (config) {
    this.s = {
      g: null,
      starBg: config.starBg,
      con: config.con,
      width: config.width,
      height: config.height,
      ttl: config.numberObject,
      xmax: config.speedX,
      ymax: config.speedY,
      rmax: config.radius,
      rt: config.pulsion,
      rint: config.rint,
      xdef: 960,
      ydef: 540,
      xdrift: 4,
      ydrift: 4,
      opacityRect: config.opacityRect,
      colorRect: config.colorRect,
      random: true,
      blink: true,
    }
  }

  reset () {
    this.x = this.s.random ? this.s.width * Math.random() : this.s.xdef
    this.y = this.s.random ? this.s.height * Math.random() : this.s.ydef
    this.r = ((this.s.rmax - 1) * Math.random()) + 1
    this.dx = Math.random() * this.s.xmax * (Math.random() < 0.5 ? -1 : 1)
    this.dy = Math.random() * this.s.ymax * (Math.random() < 0.5 ? -1 : 1)
    this.hl = (this.s.ttl / this.s.rint) * (this.r / this.s.rmax)
    this.rt = Math.random() * this.hl
    this.s.rt = Math.random() + 1
    this.stop = (Math.random() * 0.2) + 0.4
    this.s.xdrift *= Math.random() * (Math.random() < 0.5 ? -1 : 1)
    this.s.ydrift *= Math.random() * (Math.random() < 0.5 ? -1 : 1)
  }

  fade () {
    this.rt += this.s.rt
  }

  draw () {
    if (this.s.blink && (this.rt <= 0 || this.rt >= this.hl)) this.s.rt = this.s.rt * -1
    else if (this.rt >= this.hl) this.reset()
    // const e = 1 - (this.rt / this.hl)
    this.s.con.drawImage(this.s.starBg, this.x, this.y, this.r, this.r)
    this.s.con.globalAlpha = this.s.opacityRect
  //  this.s.con.beginPath();
  //  this.s.con.arc(this.x, this.y, this.r, 0, Math.PI * 2, true);
  //  this.s.con.closePath();
  //  var t = this.r * e;
  //  this.s.g = this.s.con.createRadialGradient(this.x, this.y, 0, this.x, this.y, t <= 0 ? 1 : t);
  //  this.s.g.addColorStop(1, this.s.colorRect + e * this.s.opacityRect + ")");
  //  this.s.con.fillStyle = this.s.g;
  //  this.s.con.fill()
  }

  move () {
    this.x += (this.rt / this.hl) * this.dx
    this.y += (this.rt / this.hl) * this.dy
    if (this.x > this.s.width || this.x < 0) this.dx *= -1
    if (this.y > this.s.height || this.y < 0) this.dy *= -1
  }

  getX () {
    return this.x
  }

  getY () {
    return this.y
  }
}
